export const TAX_PURCHASE = 1
export const TAX_SALES = 2

type TaxLike = {
  purchaseOrSales?: unknown
  PurchaseOrSales?: unknown
  taxPercent?: unknown
  TaxPercent?: unknown
  taxRate?: unknown
  TaxRate?: unknown
  percent?: unknown
  Percent?: unknown
  taxRateId?: unknown
  TaxRateId?: unknown
  id?: unknown
  Id?: unknown
  isDefault?: unknown
  IsDefault?: unknown
}

function num(value: unknown): number {
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}

export function taxPurchaseOrSales(tax: TaxLike | null | undefined): number {
  if (!tax) return 0
  return num(tax.purchaseOrSales ?? tax.PurchaseOrSales)
}

export function taxPercentOf(tax: TaxLike | null | undefined): number {
  if (!tax) return 0
  return num(tax.taxPercent ?? tax.TaxPercent ?? tax.taxRate ?? tax.TaxRate ?? tax.percent ?? tax.Percent)
}

export function taxIdOf(tax: TaxLike | null | undefined): number {
  if (!tax) return 0
  return num(tax.taxRateId ?? tax.TaxRateId ?? tax.id ?? tax.Id)
}

export function filterTaxesByKind<T extends TaxLike>(taxes: T[] | null | undefined, kind: number): T[] {
  const list = Array.isArray(taxes) ? taxes : []
  const matched = list.filter((t) => taxPurchaseOrSales(t) === kind)
  if (matched.length > 0) return matched
  return list.filter((t) => taxPurchaseOrSales(t) === 0)
}

export function pickDefaultTaxRate(taxRates: TaxLike[] | null | undefined): { taxRateId: number; taxRate: number } | null {
  const list = Array.isArray(taxRates) ? taxRates : []
  if (list.length === 0) return null
  const markedDefault = list.find((t) => t.isDefault === true || t.IsDefault === true)
  const fifteen = list.find((t) => Math.abs(taxPercentOf(t) - 15) < 0.01)
  const pick = markedDefault ?? fifteen ?? list[0]
  return {
    taxRateId: taxIdOf(pick),
    taxRate: taxPercentOf(pick),
  }
}
